import { Search, SlidersHorizontal } from "lucide-react";
import * as React from "react";

import { CustomButton, CustomInput } from "@/components/atoms";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { commonIconProps16 } from "@/utils/constants";
import { formatTestId } from "@/utils/formatTestId";

interface DropDownViewMenuProps {
  viewList: string[];
  visibleColumns: string[];
  setVisibleColumns: (columns: string[]) => void;
}

const DropDownViewMenu: React.FC<DropDownViewMenuProps> = ({
  viewList,
  visibleColumns,
  setVisibleColumns,
}) => {
  const [searchTerm, setSearchTerm] = React.useState("");

  const filteredList = viewList.filter(item =>
    item.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <CustomButton
          variant="filter"
          size="xs"
          data-testid="dropdown-view-trigger"
          className="px-[10px]!"
        >
          <SlidersHorizontal {...commonIconProps16} />
          <span className="text-xs">View</span>
        </CustomButton>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        className="w-53"
        align="start"
        sideOffset={5}
        alignOffset={-130}
        data-testid="dropdown-view-content"
      >
        <DropdownMenuLabel className="flex items-center gap-2 relative">
          <Search
            {...commonIconProps16}
            className="absolute top-2 left-2 z-20"
            color="#6B7280"
          />
          <CustomInput
            type="text"
            placeholder="Search columns"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            onKeyDown={e => {
              if (e.key !== "Escape") {
                e.stopPropagation();
              }
            }}
            className="placeholder:text-xs text-gray-950 font-normal border-none h-5 pl-6 focus-visible:outline-none focus-visible:ring-0"
            data-testid="dropdown-view-search-input"
            autoFocus
          />
        </DropdownMenuLabel>
        <DropdownMenuSeparator />

        {filteredList.map(elem => {
          const checked = visibleColumns.includes(elem);
          const testId = `dropdown-view-checkbox-${formatTestId(elem)}`;

          return (
            <DropdownMenuCheckboxItem
              key={elem}
              checked={checked}
              onPointerMove={e => e.preventDefault()}
              onCheckedChange={isChecked => {
                if (isChecked) {
                  /* @ts-expect-error: incorrect type */
                  setVisibleColumns(prev => [...prev, elem]);
                } else {
                  /* @ts-expect-error: incorrect type */
                  setVisibleColumns(prev => prev.filter(col => col !== elem));
                }
              }}
              className="text-sm"
              data-testid={testId}
            >
              {elem}
            </DropdownMenuCheckboxItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default DropDownViewMenu;
